import {GetStaticPaths, GetStaticProps} from 'next';
import {useRouter} from 'next/router';

import {getAllPostsFromSanityAndMarkdown} from 'utils/blog';
import BlogHome from 'components/BlogHome';
import {generateRSSFeedFile} from 'utils/rss';

export default function BlogPage(props) {
  const router = useRouter();

  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  const {page, allPosts} = props;
  if (!page && !allPosts) {
    // Handling an edge case where this page is prerendered with undefined props
    // during the build.
    return null;
  }
  return <BlogHome allPosts={allPosts} page={page} />;
}

export const getStaticProps: GetStaticProps = async ({params}) => {
  if (process.env.NODE_ENV !== 'development' && params?.page === '1') {
    try {
      await generateRSSFeedFile();
    } catch (e) {
      console.error('Error while generating RSS feed', e);
    }
  }

  const posts = await getAllPostsFromSanityAndMarkdown();

  return {props: {page: params?.page ?? 1, allPosts: posts}, revalidate: 60};
};

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = await getAllPostsFromSanityAndMarkdown();

  const totalPages = Math.ceil(posts.length / 8);

  const paths = Array.from({length: totalPages}, (_, i) => ({
    params: {page: (i + 1).toString()},
  }));

  return {
    paths,
    fallback: true,
  };
};
